import { FC, useEffect } from "react";
import { useTranslation } from "react-i18next";
import { useMediaQuery } from "react-responsive";
import clsx from "clsx";
import { PageTitle, PageLink } from "../layout/core/PageData";
// Legacy import (commented out)
// import ChatWrapper from "../layout/chat-handle/components/ChatWrapper.v2";
import { ChatWrapper } from "src/app/modules/chat/pages";
import { useHeaderVisibility } from "src/app/layouts/core/HeaderVisibilityContext";

const HandleChat: FC = () => {
  const { t } = useTranslation();
  const isTabletOrMobile = useMediaQuery({ query: "(max-width: 900px)" });
  const { setHeaderVisibility } = useHeaderVisibility();

  // Hide header on mobile when this component mounts
  useEffect(() => {
    if (isTabletOrMobile) {
      setHeaderVisibility(true); // true = hide header
    }

    // Show header again when component unmounts (navigating away)
    return () => {
      setHeaderVisibility(false);
    };
  }, [isTabletOrMobile, setHeaderVisibility]);

  return (
    <div
      className={clsx(
        "tw-flex tw-flex-col tw-w-full tw-overflow-hidden",
        isTabletOrMobile ? "tw-flex-1 tw-min-h-0" : "tw-h-full"
      )}
    >
      {/* <PageTitle>{t("SideBar.MenuItem.HC")}</PageTitle> */}
      <ChatWrapper />
    </div>
  );
};

export { HandleChat };
